<template>
    <div class="contain">
        <div class="header">
            <van-swipe :autoplay="3000" style="height: 200px;margin-top: 0px">
                <van-swipe-item v-for="(image, index) in images" :key="index">
                    <!--<img :src="image" width="100px" height="100px"/>-->
                    <div @click="linkCarouselDetail(image.id)" style="width: 100%;height: 100%">
                        <van-image
                                width="100%"
                                height="100%"
                                fit="fill"
                                :src=image.imageUrl
                        />
                    </div>
<!--                    <div :style="{width: '100%',height: '100%',backgroundSize:'cover',backgroundImage:'url('+image.imageUrl+')'}" @click="linkCarouselDetail(image.id)"></div>-->
                </van-swipe-item>
            </van-swipe>


        </div>
        <div class="notice">
            <div>
                <van-notice-bar
                        @click="showNotice"
                        color="#0BCA92"
                        background="#FFFFFF"
                        :left-icon="laba"
                        :scrollable="true"
                        :text="notice"
                >
                </van-notice-bar>
            </div>
        </div>
        <div class="travel">
            <van-cell title="常用路线选择："  title-style="color:#0CC893" :value="strokeInfo.lineName" @click="openDefaultLine"/>
            <van-cell title="开始日期：" title-style="color:#0CC893" :icon="wxChar" clickable :border="false">
                <van-field
                    input-align="left"
                    v-model="strokeInfo.startDate"
                    placeholder="开始日期"
                    label=""
                    label-width="5px"
                    readonly
                    @click="()=>{showPop = true;flag = '0'}"
                />
            </van-cell>

            <van-divider style="width: 90%;margin: 0 auto"/>
            <van-cell title="时间：" title-style="color:#0CC893" :icon="wxChar" clickable :border="false">
                <van-row type="flex">
                    <div style="width: 100px">
                        <van-field
                            input-align="left"
                            v-model="strokeInfo.startTime"
                            placeholder="开始时间"
                            label=""
                            readonly
                            label-align="center"
                            label-width="5px"
                            @click="()=>{showPop2 = true;flag = '1'}"
                        />
                    </div>
                    <div span="1"><span style="line-height: 24px;"> 至 </span></div>
                    <div span="8" style="width: 100px;text-align: right;">
                        <van-field
                            input-align="right"
                            v-model="strokeInfo.endTime"
                            placeholder="结束时间"
                            label=""
                            readonly
                            label-align="center"
                            label-width="5px"
                            @click="()=>{showPop3 = true;flag = '3'}"
                        />
                    </div>
                </van-row>
            </van-cell>


            <div align="center" style="margin-bottom: 10px">
                <van-button @click="goCarList" color="#0CC893" style="width: 95%">立即找车</van-button>
<!--                <van-button @click="goCarList_all" color="#5083ED" style="width: 95%;margin-top: 10px">查看全部</van-button>-->
            </div>
        </div>
        <CarList></CarList>

<!--        <div class="listInfo">-->

<!--            <div v-for="(item,index) in newTripList" :key="index">-->
<!--                <div class="card" @click="linkLineDetails(item.tripId)">-->
<!--                    <van-row-->
<!--                            style="border-bottom: 1px solid #ECECEC;display: flex;align-items: center;padding: 8px 2px;">-->
<!--                        <van-col span="16">-->
<!--                            <span class="datetime">{{item.tripDateTime}}</span>-->
<!--                        </van-col>-->
<!--                        <van-col span="8" style="text-align: right" v-if="item.bookSeat>0">-->
<!--                            <span>座位:</span>-->
<!--                            <span class="seatNum">{{item.bookSeat}}个</span>-->
<!--                        </van-col>-->
<!--                        <van-col span="8" style="display:flex;align-items: center;justify-content: flex-end"-->
<!--                                 v-if="item.bookSeat===0">-->
<!--                            <i class="van-icon van-icon-warning-o van-cell__left-icon" style="color: red"/>-->
<!--                            <span  style="color: red;font-weight: bold;"> 车满</span>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                    <van-row style="border-bottom: 1px solid #ECECEC;display: flex;align-items: center;">-->
<!--                        <van-col span="16">-->
<!--                            <p class="datetime"><i class="greenBar"></i>{{item.startPlace}}</p>-->
<!--                            <p class="datetime"><i class="redBar"></i>{{item.endPlace}}</p>-->
<!--                        </van-col>-->
<!--                        <van-col span="8" style="text-align: right">-->
<!--                            <div class="price">￥{{item.tripPrice}}</div>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                    <van-row style="padding: 0px 2px;display: flex;align-items: center;">-->
<!--                        <van-col span="6">-->
<!--                            <van-image-->
<!--                                    round-->
<!--                                    fit="cover"-->
<!--                                    width="60"-->
<!--                                    height="60"-->
<!--                                    :src="item.headimgurl"-->
<!--                            />-->
<!--                        </van-col>-->
<!--                        <van-col span="18">-->
<!--                            <p style="display: flex;align-items: center"><span style="color: #5083ED">【车主】</span>-->
<!--                                {{item.nickname}}-->
<!--                                <img src="../../static/images/man.png"-->
<!--                                     style="width: 13px;height: 13px;display: inline-block;margin-left: 5px"-->
<!--                                     v-if="item.sex === 1">-->
<!--                                <img src="../../static/images/sexTag.png"-->
<!--                                     style="width: 13px;height: 13px;display: inline-block;margin-left: 5px" v-else></p>-->
<!--                            <p><span>【车型】</span>{{item.carName}}</p>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                </div>-->
<!--            </div>-->
<!--            &lt;!&ndash;</van-list>&ndash;&gt;-->
<!--        </div>-->


        <div class="footer">
            <van-tabbar v-model="active" active-color="rgb(12, 200, 147)" inactive-color="#FFFFFF"
                        style="background:#5083ED ">
                <van-tabbar-item :icon="chengK" to="/carIndex">我是乘客</van-tabbar-item>
                <van-tabbar-item :icon="xingC" to="/myStroke">我的行程</van-tabbar-item>
                <van-tabbar-item :icon="push" to="/pushStroke">发布行程</van-tabbar-item>
                <van-tabbar-item :icon="person" to="/user?flag=1">个人中心</van-tabbar-item>
            </van-tabbar>
        </div>

        <van-popup
                v-model="showPop"
                position="bottom"
                :style="{ height: '30%' }"
        >
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    :min-date="minDate"
                    :visible-item-count="3"
                    @cancel="cancel"
                    @confirm="changeTimer"
            />
        </van-popup>
        <van-popup
            v-model="showPop2"
            position="bottom"
            :style="{ height: '30%' }"
        >
            <van-datetime-picker
                v-model="currentDate2"
                type="time"
                :min-date="minDate"
                :visible-item-count="3"
                @cancel="cancel"
                @confirm="changeTimer"
                :min-hour="0"
                :max-hour="23"
            />
        </van-popup>
        <van-popup
            v-model="showPop3"
            position="bottom"
            :style="{ height: '30%' }"
        >
            <van-datetime-picker
                v-model="currentDate3"
                type="time"
                :min-date="minDate"
                :visible-item-count="3"
                @cancel="cancel"
                @confirm="changeTimer"
                :min-hour="0"
                :max-hour="23"
            />
        </van-popup>
        <van-popup
                v-model="showLinePop"
                position="bottom"
                :style="{ height: '30%' }"
        >
            <van-picker
                    show-toolbar
                    title=""
                    :visible-item-count="3"
                    :columns="columns"
                    @cancel="showLinePop = false"
                    @confirm="changeDefaultLine"
            />
        </van-popup>
    </div>
</template>

<script>
    import {
        NavBar,
        Row,
        Col,
        Image,
        NoticeBar,
        Cell,
        CellGroup,
        Field,
        Divider,
        Icon,
        Dialog,
        Button,
        Card,
        Tabbar,
        TabbarItem,
        DatetimePicker,
        Popup,
        List,
        Picker,
        Swipe,
        SwipeItem
    } from 'vant';
    import Title from './../../components/header'
    import logo from './../../static/images/logo.png'
    import laba from './../../static/images/laba.png'
    import greenBar from './../../static/images/green.png'
    import redBar from './../../static/images/red.png'
    import timeBar from './../../static/images/timer.png'

    import chengK from './../../static/images/chengk.png'
    import xingC from './../../static/images/xingC.png'
    import push from './../../static/images/push.png'
    import person from './../../static/images/chengk.png'


    import request from '../../utils/request'
    import moment from 'moment'
    import carList from '@/view/carpool/carLine_mode.vue'

    export default {
        name: "carIndex",
        components: {
            Title,
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Image.name]: Image,
            [NoticeBar.name]: NoticeBar,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Divider.name]: Divider,
            [Button.name]: Button,
            [Card.name]: Card,
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
            [DatetimePicker.name]: DatetimePicker,
            [Popup.name]: Popup,
            [List.name]: List,
            [Picker.name]: Picker,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [Icon.name]: Icon,
            [Dialog.name]:Dialog,
            'CarList': carList
        },
        data() {
            return {
                title: "共享拼车",
                images: [],
                newTripList: [],
                flag: "0",
                notice: "",
                columns: [],
                lineList: [],
                showLinePop: false,
                error: false,
                loading: false,
                minDate: new Date(),
                currentDate: "",
                currentDate2: "",
                currentDate3: "",
                showPop: false,
                showPop2: false,
                showPop3: false,
                logo: logo,
                laba: laba,
                greenBar: greenBar,
                redBar: redBar,
                timeBar: timeBar,
                chengK: chengK,
                xingC: xingC,
                push: push,
                person: person,
                active: 0,
                strokeInfo: {
                    startPlace: "",
                    endPlace: "",
                    driveTime: "",
                    week: "",
                    startDate: this.getNowDate(),
                    startTime: this.getNowTime(),
                    endTime: "23:59",
                    endDate: "",
                    lineId: "",
                    lineName: ""
                },
                notice2:''
            }
        },
        mounted() {
            // if (localStorage.getItem('openid') && localStorage.getItem("isLogin") === '1') {
            //     let openid = localStorage.getItem('openid');
            //     config.headers['openid'] = openid;
            // } else {
            //     localStorage.clear();
            //     server.axios.get('/wx/syncauthorize')
            //         .then(function (response) {
            //                 if (response.data.code === 0) {
            //                     //获取到验证URL,给微信发送请求
            //                     let authURL = response.data.data.url;
            //                     // console.log(authURL);
            //                     window.location.href = authURL;
            //                 }
            //             }
            //         ).catch(function (error) {
            //         console.log(error);
            //     });
            //     throw new Error("logout");
            // }

            // let url = location.href;
            // if (url.indexOf("code") != -1) {
            //     let str = url.substr(url.indexOf("?") + 1);
            //     let strs = str.split("&");
            //     let code = strs[0].split("=")[1];
            //     let url2 = "/wx/getopenid?" + qs.stringify({code: code});
            //     request.axios.get(url2).then(res => {
            //         if (res.data.code === 0) {
            //             let openid = res.data.data.openid;
            //             localStorage.setItem("openid", openid);
            //             request.axios.post(
            //                 '/wx/login', qs.stringify({openid: openid})).then((res) => {
            //                 if (res.data.code === 0) {
            //                     if (res.data.data.isLogin === "1") {
            //                         //登陆成功
            //                         localStorage.setItem("isLogin", "1");
            //                         window.location.href = location.protocol+"//"+location.hostname + "/#/user";
            //                     }
            //                 } else if(res.data.code === 2){
            //                     window.location.href = location.protocol+"//"+location.hostname + "/#/register";
            //                 }else{
            //                     this.$toast(res.data.msg);
            //                 }
            //             })
            //         }else if(res.data.code === 2){
            //             window.location.href = location.protocol+"//"+location.hostname + "/#/register";
            //         }else{
            //             this.$toast(res.data.msg);
            //         }
            //     }).catch(error => {
            //         console.log(error);
            //     });
            // }else{
                //初始化列表
                this.initListData();

                this.initNotice();

                this.initAdvList();
                this.initLineData();
            // }

        },
        methods: {
            //轮播详情
            linkCarouselDetail(val){
                this.$router.push({path: '/carouselDetail', query: {id: val}})
            },

            showNotice(){
                let notice = this.notice2;
                Dialog.alert({
                    title: '通知',
                    confirmButtonText:'关闭',
                    confirmButtonColor:'#0CC893',
                    message: notice
                }).then(() => {
                    // on close
                });
            },
            //详情
            linkLineDetails(val) {
                this.$router.push({path: "/lineDetails", query: {tripId: val}})
            },

            //通知
            initNotice() {
                request.sendGet({
                    url: "/common/notice/list",
                    params: {}
                }).then(res => {
                    if (res.data.code == '0') {
                        let list = res.data.data;
                        list.forEach(e => {
                            this.notice += " ★ " + e.title + ' ★ ' + e.context + " ";
                            this.notice2 += "<p> ★" + e.title + ' ★ </p><p>' + e.context + "</p>";
                        });
                    }
                })

            },

            //广告位
            initAdvList() {
                //1-拼车 2-班车 3-班车验票
                let positionId = 1;
                request.sendGet({
                    url: "/common/advertlist/" + positionId,
                    params: {}
                }).then(res => {
                    if (res.data.code == '0') {
                        this.images = res.data.data;
                    }
                })
            },

            //常用线路
            changeDefaultLine(val) {
                this.lineList.forEach(e => {
                    if (e.lineName == val) {
                        let arr = [];
                        arr = e.lineName.split("--");
                        this.strokeInfo.startPlace = arr[0];
                        this.strokeInfo.endPlace = arr[1];
                        this.strokeInfo.lineId = e.lineId;
                        this.strokeInfo.lineName = e.lineName;
                    }
                });
                this.showLinePop = false;
            },

            openDefaultLine() {
                this.showLinePop = true;
            },
            initLineData() {
                request.sendGet({
                    url: "/user/center/linelist",
                    params: {}
                }).then(res => {
                    if (res.data.code === 0) {
                        //处理数据
                        this.lineList = res.data.rows;
                        this.columns = [];
                        this.lineList.forEach(e => {
                            this.columns.push(e.lineName);
                            if (e.isDefault === 1) {
                                let arr = [];
                                arr = e.lineName.split("--");
                                this.strokeInfo.startPlace = arr[0];
                                this.strokeInfo.endPlace = arr[1];
                                this.strokeInfo.lineId = e.lineId;
                                this.strokeInfo.lineName = e.lineName;
                            }
                        });
                    }
                });
            },

            //列表
            initListData() {
                request.sendGet({
                    url: "/sharecar/pass/newtrips",
                    params: {}
                }).then(res => {
                    if (res.data.code == '0') {
                        this.newTripList = res.data.rows;
                    }
                })
            },

            cancel() {
                this.showPop = false ;
                this.showPop2 = false ;
                this.showPop3 = false
            },

            changeTimer(val) {
                var timer = moment(val).format("YYYY-MM-DD");
                // this.strokeInfo.driveTime = timer;
                if (this.flag == '0') {
                    this.strokeInfo.startDate = timer;
                    let week = moment(val).format('d');
                    this.strokeInfo.week = week;
                } else {
                    var s, e;
                    var s_t, e_t;
                    if (this.flag == 1) {
                        if(!this.strokeInfo.startDate){
                            this.$toast('请先选择开始日期。') ;
                            return false ;
                        }
                        if(this.strokeInfo.endTime){
                            s = this.strokeInfo.startDate + ' ' + val ;
                            e = this.strokeInfo.startDate + ' ' + this.strokeInfo.endTime ;
                            s_t = moment(s, 'YYYY-MM-DD HH:mm').valueOf() ;
                            e_t = moment(e, 'YYYY-MM-DD HH:mm').valueOf() ;
                            if(s_t > e_t){
                                this.$toast('结束时间不能早于开始时间。') ;
                                return false ;
                            }
                        }
                        this.strokeInfo.startTime = val;
                    }else{
                        if(!this.strokeInfo.startTime){
                            this.$toast('请先选择开始时间。') ;
                            return false ;
                        }
                        s = this.strokeInfo.startDate + ' ' + this.strokeInfo.startTime ;
                        e = this.strokeInfo.startDate + ' ' + val ;
                        s_t = moment(s, 'YYYY-MM-DD HH:mm').valueOf() ;
                        e_t = moment(e, 'YYYY-MM-DD HH:mm').valueOf() ;
                        if(s_t > e_t){
                            this.$toast('结束时间不能早于开始时间。') ;
                            return false ;
                        }
                        this.strokeInfo.endTime = val;
                    }
                }
                this.showPop = false;
                this.showPop2 = false;
                this.showPop3 = false;
            },

            async onLoad() {

            },

            onClickLeft() {
                // this.$toast('返回');
                this.$router.back(-1);
            },

            goCarList() {
                // console.log(this.strokeInfo)
                // if(!this.strokeInfo.startPlace){
                //     this.$toast.fail("请填写出发地点");
                //     return;
                // }
                // if(!this.strokeInfo.endPlace){
                //     this.$toast.fail("请填写目的地点");
                //     return;
                // }
                // if(!this.strokeInfo.driveTime){
                //     this.$toast.fail("请填写乘车时间");
                //     return;
                // }
                if (!this.strokeInfo.startDate) {
                    this.$toast.fail("请填写开始日期");
                    return;
                }
                if (!this.strokeInfo.startTime) {
                    this.$toast.fail("请填写结束时间");
                    return;
                }
                if (!this.strokeInfo.endTime) {
                    this.$toast.fail("请填写结束时间");
                    return;
                }
                if (!this.strokeInfo.lineId) {
                    this.$toast.fail("请选择路线");
                    return;
                }
                this.strokeInfo.startDateParam = this.strokeInfo.startDate + ' ' + this.strokeInfo.startTime;
                this.strokeInfo.endDateParam = this.strokeInfo.startDate + ' ' + this.strokeInfo.endTime;
                sessionStorage.removeItem("queryStroke");
                sessionStorage.setItem("queryStroke", JSON.stringify(this.strokeInfo));
                this.$router.push({path: '/carLine'});
            },
            goCarList_all() {
                if (!this.strokeInfo.lineId) {
                    this.$toast.fail("请选择路线");
                    return;
                }
                let week = moment(new Date()).format('d');
                this.strokeInfo.week = week;

                sessionStorage.removeItem("queryStroke");
                sessionStorage.setItem("queryStroke", JSON.stringify(this.strokeInfo));
                this.$router.push({path: '/carLine'});
            },
            getNowDate(){
                let date = new Date();
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                let d = date.getDate();
                m = m < 10 ? "0" + m : m;
                d = d < 10 ? "0" + d : d;
                return y + "-" + m + "-" + d;
            },
            getNowTime(){
                let date = new Date();
                let H = date.getHours();
                let mm = date.getMinutes();
                H = H < 10 ? "0" + H : H;
                mm = mm < 10 ? "0" + mm : mm;
                return  H + ":" + mm;
            }
        },

    }
</script>

<style scoped>

    /*.van-nav-bar {*/
    /*position: relative;*/
    /*height: 46px;*/
    /*line-height: 46px;*/
    /*text-align: center;*/
    /*background-color:transparent;*/
    /*-webkit-user-select: none;*/
    /*user-select: none;*/
    /*}*/
    /*.van-hairline--bottom::after {*/
    /*border-bottom-width: 0px;*/
    /*}*/

    /*.van-icon-arrow-left{*/
    /*color: #fff;*/
    /*}*/

    /*.van-nav-bar__title {*/
    /*max-width: 60%;*/
    /*margin: 0 auto;*/
    /*color: #fff;*/
    /*font-weight: 500;*/
    /*font-size: 16px;*/
    /*}*/

    .contain {
        background: #F6F6F6;
        overflow-x: hidden;
    }

    .notice {
        background: #FFFFFF;

    }

    .logo {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .header {
        /*background-image: linear-gradient(49deg, #05CF8A, #5C77FE);*/
        /*opacity:1;*/
    }

    .tag {
        color: #fff;
    }

    .travel {
        background: #fff;
        margin-bottom: 10px;
        border: 1px solid #f1f1f1;
    }

    .listInfo {
        margin-bottom: 60px;
    }

    .listInfo .card {
        width: 90%;
        margin: 0 auto;
        font-size: 14px;
        padding: 10px 5px;
        margin-bottom: 10px;
        background: #fff;
        border-radius: 5px;
    }

    .datetime {
        color: #5E5E5E;
        padding-left: 8px;
    }

    .seatNum {
        font-weight: bold;
        margin-left: 8px;
    }

    .greenBar {
        border-radius: 50%;
        background: rgb(12, 200, 147);
        width: 10px;
        height: 10px;
        display: inline-block;
        margin-right: 5px;
    }

    .redBar {
        border-radius: 50%;
        background: rgb(255, 42, 35);
        width: 10px;
        height: 10px;
        display: inline-block;
        margin-right: 5px;
    }

    .price {
        height: 100%;
        width: 100%;
        font-size: 22px;
        color: red;
    }

    .footer {
        width: 100%;
    }


    .van-cell__value {
        text-align: left;
        color: #323233!important;
    }
    .van-field__control{
        color: #969799!important;
    }
    /deep/ .van-field__control:disabled{
        color: #333333!important;
    }
    .van-cell__title{
        width: 200px!important;
        flex: .5;
        -webkit-box-flex:  .5;
    }
    .van-field{
        padding: 0px!important;
    }

</style>
